import React, { FC, PropsWithChildren } from "react";
import cn from "classnames";

type Props = PropsWithChildren<{
  title?: string;
  subTitle?: string;
  className?: string;
}>;

const Card: FC<Props> = ({ title, subTitle, className, children }) => {
  const hasHeader = Boolean(title || subTitle);
  return (
    <div
      className={cn(
        "rounded-[10px] border border-slate-200 bg-white",
        className && className
      )}
    >
      {hasHeader && (
        <div
          className={cn(
            "px-5 pt-4 pb-3",
            children !== undefined && children !== null && children !== false
              ? "border-b border-slate-100"
              : ""
          )}
        >
          {title && (
            <h2 className="font-semibold text-base tracking-tight text-slate-900">
              {title}
            </h2>
          )}
          {subTitle && (
            <h3 className="text-xs text-slate-500 mt-0.5 font-normal">
              {subTitle}
            </h3>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default Card;
